import React, { useState, useContext } from "react";
import { Link } from "gatsby";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { VID, PREVIEW } from "../project-config.js";
// import { VID, PROJECT_LINK, PREVIEW } from "../project-config.js";
import ProfileIcon from "../assets/img/Profile.png";
import Modal from "../shared/components/UIElements/Modal";
import Drawer from "@material-ui/core/Drawer";
import LazyLoad from "react-lazyload";
import Login from "../components/AC-LoginBox/Login";
import { I18nContext } from "../i18n";
import Popover from "@material-ui/core/Popover";
import Divider from "@material-ui/core/Divider";

import { handleLogout } from "../redux/actions/loginActions.js";

export default function Profile({ modalOpenedByIcon, setModalOpened }) {
  const dispatch = useDispatch();
  const { langCode, translate } = useContext(I18nContext);

  const [Loginstate, LoginsetState] = useState({
    top1: false,
    left1: false,
    bottom1: false,
    right1: false,
  });

  const [AfterLoginstate, AfterLoginsetState] = useState({
    top1: false,
    left1: false,
    bottom1: false,
    right1: false,
  });

  const toggleDrawerLogin = (side, open) => (event) => {
    if (event.key === "Tab" || event.key === "Shift") {
      return;
    }

    LoginsetState({ ...Loginstate, [side]: open });
  };

  const toggleDrawerAfterLogin = (side, open) => (event) => {
    if (event.key === "Tab" || event.key === "Shift") {
      return;
    }

    AfterLoginsetState({ ...AfterLoginstate, [side]: open });
  };

  const sideListLogin = (side) => (
    <div role="presentation">
      <Login />
    </div>
  );

  const securityTokenState = useSelector(
    (state) => state.loginReducer.securityToken,
    shallowEqual
  );
  const loginNameState = useSelector(
    (state) => state.loginReducer.loginName,
    shallowEqual
  );

  const firstnameState = useSelector(
    (state) => state.loginReducer.firstname,
    shallowEqual
  );

  const languageState = useSelector(
    (state) => state.mainReducer.lang,
    shallowEqual
  );

  const logout = (e) => {
    e.preventDefault();
    dispatch(handleLogout(securityTokenState));
  };

  // Code for slider login starts------

  // const [open, setOpen] = React.useState(false);

  // React.useEffect(() => {
  //   setOpen(modalOpenedByIcon);
  // }, [modalOpenedByIcon]);

  // React.useEffect(() => {
  //   setModalOpened(open);
  // }, [open]);

  // const handleClick = () => {
  //   setOpen(prev => !prev);
  // };

  // const handleClickAway = () => {
  //   setOpen(false);
  // };

  // Code for slider login ends--------
  // Code for popper login starts-------

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "login-popover" : undefined;

  return loginNameState !== "" ? (
    <LazyLoad height={18} offset={100} debounce={300} fadein={true}>
      <div id="login-icon-btn" className="icon-wrapper" onClick={handleClick}>
        <div className="icon-wrapper">
          <i className="material-icons">account_circle</i>
        </div>
      </div>
      <div className="login-text-container" onClick={handleClick}>
        <span className="icon-action-text">{firstnameState}</span>
      </div>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <div className="signinpopper" onClick={handleClose}>
          {/* <div style={{ backgroundColor: "#fff", color: "#555" }}>
            <Link class="signin-btn" to={PREVIEW + "/login"}>Sign In</Link>
            <div className="signupblock">First time here?
                    <Link class="signup-btn" to={PREVIEW + "/register.html?vid=20180521148&mt=1&ml=en"}>Sign Up</Link>
            </div>
          </div>
          <Divider /> */}
          <div>
            <ul className="user-profile-dropdown">
              <a
                href={`${PREVIEW}/myaccount.html?mode=customerinfo&vid=${VID}&iu=${languageState}`}
              >
                <li className="myaccount-box">My Profile</li>
              </a>
              <a
                href={`${PREVIEW}/myaccount.html?mode=messages&vid=${VID}&iu=${languageState}`}
              >
                <li className="myaccount-box">My Enquires</li>
              </a>

              <a onClick={logout}>
                <li className="myaccount-box">
                  <form
                    name="logoutPopup"
                    className="logoutPopup"
                    onSubmit={logout}
                    autoComplete="on"
                  >
                    <button type="submit">
                      {" "}
                      {translate("jsp.header_logout")}
                    </button>
                  </form>
                </li>
              </a>
            </ul>
          </div>
        </div>
      </Popover>

      {/* <Modal
        className="fim-dropdown sign-display display-signin"
        show={open}
        onCancel={handleClickAway}
        style={{ zIndex: "9999" }}
        dropDownList={true}
        noClass
        noHeader
        noFooter
      >
        
      </Modal> */}
    </LazyLoad>
  ) : (
    <React.Fragment>
      <div id="login-icon-btn" className="icon-wrapper" onClick={handleClick}>
        {/* <img
          src={ProfileIcon}
          alt="Profile"
          className="img-responsive iconInfo3"
        /> */}
      </div>
      <div className="login-text-container" onClick={handleClick}>
        <div className="icon-wrapper">
          <i className="material-icons">account_circle</i>
        </div>
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <div className="signinpopper" onClick={handleClose}>
          <div style={{ backgroundColor: "#fff", color: "#555" }}>
            <Link className="signin-btn" to={"/login"}>
              Sign In As A Buyer
            </Link>
            <div className="signupblock">
              First time here?
              <a
                className="signup-btn"
                href={PREVIEW + `/register.html?vid=${VID}&mt=1&ml=en`}
              >
                Sign up now
              </a>
            </div>
          </div>
          <Divider />
        </div>
      </Popover>
    </React.Fragment>
  );
}
